import React, { useState } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useChartToolbar } from "../../common/function/useChartToolbar";

interface Measurement {
  mainState: number;
  subState: number;
}

interface StimulationChartProps {
  xAxisData: string[];
  measurements: Measurement[];
}

const StimulationChart: React.FC<StimulationChartProps> = ({ xAxisData, measurements }) => {
  const toolbar = useChartToolbar();

  // Compute data from measurements:
  // If mainState is 3 then: if subState is even → 0, if odd → 1.
  const dataArray: number[] = measurements.map((m) => {
    if (m.mainState === 3) {
      return (m.subState % 2 === 0) ? 0 : 1;
    }
    return 0;
  });

  const [state] = useState({
    series: [
      {
        name: "Stimulation",
        data: dataArray,
      },
    ],
    options: {
      chart: {
        toolbar,
        type: "line" as "line",
        height: 350,
      },
      stroke: {
        curve: "stepline" as "stepline",
        width: 2,
      },
      xaxis: {
        categories: xAxisData,
        tickAmount: 10,
        labels: {
          style: {
            fontSize: "12px",
            colors: "#7B7484",
          },
        },
      },
      yaxis: {
        title: {
          text: "Stimulation",
          style: {
            fontSize: "12px",
            fontFamily: "Poppins",
            fontWeight: 400,
            color: "#202224",
          },
        },
        labels: {
          style: {
            fontSize: "12px",
            colors: "#7B7484",
          },
        },
        min: 0,
        max: 1,
        tickAmount: 2,
      },
      grid: {
        borderColor: "#E9E9E9",
        strokeDashArray: 4,
      },
      tooltip: {
        enabled: true,
        theme: "light",
      },
      colors: ["#3B9CB9"],
    } as ApexOptions,
  });

  return (
    <div>
      <Chart options={state.options} series={state.series} type="line" height={567} />
    </div>
  );
};

export default StimulationChart;
